// extracted by mini-css-extract-plugin
module.exports = {"generalNutritionPage":"GeneralNutritionPage_generalNutritionPage__tFfcy","certifiedInstructors":"GeneralNutritionPage_certifiedInstructors__JTaFe"};